<style>
.info-main {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 15px;
}

.info-main > *:not(:last-child) {
  padding-bottom: 4px;
  border-bottom: 1px #f5f5f5 solid;
}

.info-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.info-item > div:first-child {
  flex-basis: 30%; /* Adjust the percentage as needed for your layout */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-item > div:last-child {
  flex-grow: 1;
  text-align: right;
}
</style>

<template>
  <div class="info-main">
    <div v-for="(info, index) in infos" v-if="utils.string.vNotEmpty(info.value)" :key="index" class="info-item">
      <div style="color:#989898">{{ info.label }}</div>
      <div>{{ info.value }}</div>
    </div>
  </div>
</template>

<script>
import {utils} from "@/util/utils";

export default {
  name: 'info',
  computed: {
    utils() {
      return utils;
    }
  },
  props: {
    infos: {}
  }
}
</script>
